import React from "react";
import PropTypes from "prop-types";
import { typography, textColors } from "../../tokens";
import { GlobeIcon } from "../../icons";

/**
 * AuthNetworkErrorState
 *
 * Auth-page friendly network error message.
 * - No retry button (avoids a redundant CTA under auth forms)
 * - Copy does not include "try again" (user can edit inputs and submit normally)
 */
const AuthNetworkErrorState = ({
  title = "Network error :(",
  description = "We couldn't complete this request right now. Please check your connection.",
  className = "",
  ...props
}) => {
  return (
    <div className={`text-center py-8 px-4 ${className}`} {...props}>
      <div className="flex justify-center mb-3">
        <GlobeIcon size="3xl" color="neutral" aria-hidden="true" />
      </div>

      <div className={`${typography.h5} ${textColors.primary} mb-2`}>{title}</div>
      <div className={`${typography.bodySmall} ${textColors.tertiary} max-w-md mx-auto`}>
        {description}
      </div>
    </div>
  );
};

AuthNetworkErrorState.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  className: PropTypes.string,
};

export default AuthNetworkErrorState;


